import React from 'react';
import { FDSecondaryActionButton } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { buildPageLink } from 'Views/Page/Content/Templates';
import { advisorPage, advisorPageMessages } from 'Consts/Strings';
import {
  advisorHouseholdTimelineUri,
  advisorWhatIfPageUri,
  taskBoardUri,
} from 'Consts/advisorUris';
import { missionControlURL } from 'Hooks/useMissionControlURL';
import { balanceSheetPageURL } from 'Hooks/useBalanceSheetPageURL';
import useUserContext from 'Context/UserContext';

const PrimaryActionButton = ({ resource }) => {
  const { isAgent } = useUserContext();
  const buildTimelineHref = (householdId) => {
    return advisorHouseholdTimelineUri(householdId);
  };

  const buildMessageHref = (sourceRelationship) => {
    const params = resource?.withRelationship(
      fr.relationships.source.name,
      (rel) => rel.link('related').url(),
      () => {
      },
    );
    return buildPageLink(sourceRelationship.link('related'), advisorPageMessages, params);
  };

  const buildActionItemHref = (navigateRelationship) => {
    return taskBoardUri({
      link: navigateRelationship.link('related').url(),
    });
  };

  const buildWhatIfHref = (navigateRelationship) => {
    return advisorWhatIfPageUri(navigateRelationship.link('related').url(), resource.attr('householdId'));
  };

  const buildHref = () => {
    const sourceRelationship = resource?.relationship(fr.relationships.source.name);
    if (!sourceRelationship) {
      return null;
    }

    // Due to tech debt, navigating to a feature can take multiple forms.  Using the resource type, determine how to navigate to the feature.
    switch (sourceRelationship?.meta('resourceType')) {
      case 'timeline': {
        return buildTimelineHref(resource.attr('householdId'));
      }
      case 'message': {
        return buildMessageHref(sourceRelationship);
      }
      case 'meeting': {
        return missionControlURL(resource, resource.attr('householdId'));
      }
      case 'simpleActionItem': {
        return buildActionItemHref(sourceRelationship);
      }
      case 'FacetPlanScenarioPage': {
        return buildWhatIfHref(sourceRelationship);
      }
      case 'account': {
        return balanceSheetPageURL(resource, resource.attr('householdId'), isAgent);
      }
      default:
        return buildPageLink(sourceRelationship.link('related'), advisorPage);
    }
  };

  const href = buildHref();

  return (
    <FDSecondaryActionButton
      label={resource.relationship(fr.relationships.source.name)?.meta('prompt')}
      src={resource.relationship(fr.relationships.source.name)?.link('related').url()}
      href={href}
    />
  );
};

PrimaryActionButton.defaultProps = {};

PrimaryActionButton.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default PrimaryActionButton;
